'use client'

import { useAction } from 'next-safe-action/hooks'

import { hostConversion as _hostConversion } from '@/entities/auth'
import { THostConversionRequest } from '@/entities/auth'
import { useServerErrorHandler } from '@/shared/config/action'
import { useSession } from '@/shared/lib'

export const useHostConversion = ({ onSuccess }: { onSuccess: () => void }) => {
  const { handleServerError } = useServerErrorHandler()
  const session = useSession()

  const action = useAction(_hostConversion, {
    onSuccess: () => {
      void session.update()

      onSuccess()
    },
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  const hostConversion = ({ body }: THostConversionRequest) => {
    action.execute({ body })
  }

  return { hostConversion }
}
